<template>
  <v-container
    fluid
    class="analytics-revamp analytics-revamp--modern oms-list-page oms-list-page--analytics analytics-page"
  >
    <v-card class="analytics-panel oms-list-panel">
      <loading :active.sync="loading" />

      <section class="analytics-nav oms-list-nav">
        <SegmentedControl
          class="analytics-primary-tabs"
          aria-label="Analytics view"
          :value="currentTab"
          :options="analyticsTabOptions"
          @change="viewTab"
        />
      </section>

      <v-flex
        class="analytics-tab-panel"
        v-if="currentTab == 'redash'"
        md12
      >
        <redash :currentTab="currentTab" />
      </v-flex>
      <v-flex
        class="analytics-tab-panel"
        v-if="currentTab == 'customerDashboard'"
        md12
      >
        <customerDashboard :currentTab="currentTab" />
      </v-flex>
      <v-flex
        class="analytics-tab-panel"
        v-if="currentTab == 'reports'"
        md12
      >
        <reports :currentTab="currentTab" />
      </v-flex>
    </v-card>
  </v-container>
</template>

<script>
import Loading from "vue-loading-overlay";
import { StorageKeys } from "../../constants/constants";
import redash from "./redash";
import customerDashboard from "./customerDashboard";
import reports from "./reports";
import salesReport from "./salesReport.vue";
import purchaseAdvance from "./purchaseAdvance.vue";
import moment from "moment";
import { EventBus } from "../../event-bus.js";
import SegmentedControl from "@/components/Common/SegmentedControl";

export default {
  mounted() {
    if (localStorage.getItem("tabAnalaytics") != null) {
      this.currentTab = localStorage.getItem("tabAnalaytics");
      this.viewTab(this.currentTab);
    } else {
      this.currentTab = "redash";
      this.viewTab(this.currentTab);
    }
  },
  created() {
    this.track("Redash", {
      $email: localStorage.getItem("email"),
      $name: localStorage.getItem("user"),
      WorkingCountry: localStorage.getItem("workingCountry"),
    });
    this.$eventBus.$on("off-load", () => {
      this.loading = false;
    });
    this.track("Redash", {
      $email: localStorage.getItem("email"),
      $name: localStorage.getItem("user"),
      WorkingCountry: localStorage.getItem("workingCountry"),
    });
  },
  components: {
    Loading,
    redash,
    customerDashboard,
    reports,
    salesReport,
    purchaseAdvance,
    SegmentedControl,
  },
  data() {
    return {
      loading: true,
      currentTab: "redash",
      TabStatus: "redash",
      isBid: false,
    };
  },
  computed: {
    analyticsTabOptions() {
      return [
        {
          label: "Qlik Sense",
          value: "redash",
          icon: "insert_chart_outlined",
        },
      ];
    },
  },
  props: {
    jobId: Number,
    _id: String,
  },

  methods: {
    viewTab(flag) {
      if (flag == "redash") {
        localStorage.setItem("tabAnalaytics", flag);
        this.track("Redash", {
          $email: localStorage.getItem("email"),
          $name: localStorage.getItem("user"),
          WorkingCountry: localStorage.getItem("workingCountry"),
        });
      } else if (flag == "salesReport") {
        localStorage.setItem("tabAnalaytics", flag);
      } else if (flag == "purchaseReport") {
        localStorage.setItem("tabAnalaytics", flag);
      } else {
        localStorage.setItem("tabAnalaytics", flag);

        this.track("Customer Dashboard", {
          $email: localStorage.getItem("email"),
          $name: localStorage.getItem("user"),
          WorkingCountry: localStorage.getItem("workingCountry"),
        });
      }
      this.currentTab = flag;
    },

    getTime(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
  },
};
</script>

<style>
#nav .analytics-page.oms-list-page {
  padding: var(--oms-list-page-padding, 0.75rem 1.75rem 1.5rem) !important;
}

#nav .analytics-page .analytics-panel {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 7rem);
}

#nav .analytics-page .analytics-nav {
  grid-template-columns: minmax(0, max-content);
}

#nav .analytics-page .analytics-primary-tabs,
#nav .analytics-page .analytics-primary-tabs.segmented-control {
  background: #edebe5 !important;
  border: 0 !important;
  box-shadow: none !important;
  width: fit-content;
}

#nav .analytics-page .analytics-primary-tabs .segmented-control__item,
#nav .analytics-page .analytics-primary-tabs button {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: auto !important;
  letter-spacing: 0 !important;
  min-height: 1.75rem !important;
  min-width: max-content !important;
  padding: 0.4375rem 0.75rem !important;
  text-transform: none !important;
}

#nav .analytics-page .analytics-primary-tabs .segmented-control__item--active {
  background: #ffffff !important;
  box-shadow: 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.13) !important;
  color: var(--oms-ink-strong, #1a1916) !important;
}

#nav .analytics-page .analytics-primary-tabs .segmented-control__item--active .segmented-control__label,
#nav .analytics-page .analytics-primary-tabs .segmented-control__item--active .v-icon {
  color: var(--oms-ink-strong, #1a1916) !important;
}

#nav .analytics-page .analytics-primary-tabs .segmented-control__item .v-icon,
#nav .analytics-page .analytics-primary-tabs .segmented-control__label {
  color: inherit !important;
}

#nav .analytics-page .analytics-tab-panel {
  min-width: 0;
  padding: 0 !important;
}
</style>
